import { render, staticRenderFns } from "./WhoUs2.vue?vue&type=template&id=3379e7d8&scoped=true&"
import script from "./WhoUs2.vue?vue&type=script&lang=js&"
export * from "./WhoUs2.vue?vue&type=script&lang=js&"
import style0 from "./WhoUs2.vue?vue&type=style&index=0&id=3379e7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3379e7d8",
  null
  
)

export default component.exports